import { useContext, useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { SiteSettingsContext, useOtherSettings } from '@namespace/cms';
import type {
  CasinoConfig,
  GameServiceConfig,
  SiteSettings
} from '@namespace/cms/src/api/getSiteSettings/schemes/siteSettings';
import { CASINO_TYPE } from '../../constants';
import type { CasinoTypeUnion } from '../../types';

const formatOtherSettingsGamesService = (
  gamesService: CasinoConfig
): GameServiceConfig => {
  const { pageGeneralRouteName, ...rest } = gamesService;

  return {
    ...rest,
    ...(pageGeneralRouteName ? { lobbyRouteName: pageGeneralRouteName } : {})
  };
};

export const useCasinoSettings = (
  casinoType?: CasinoTypeUnion | null
): GameServiceConfig => {
  const [settings] = useContext<SiteSettings>(SiteSettingsContext);
  const otherSettings = useOtherSettings();
  const { gamesServices = [] } = settings;

  return useMemo(() => {
    const gamesServiceCasinoSettings = gamesServices.find(
      (gamesService) => gamesService.serviceName === casinoType
    );

    if (!isEmpty(gamesServiceCasinoSettings)) {
      return gamesServiceCasinoSettings;
    }

    const otherSettingsGameService: CasinoConfig =
      otherSettings.casinoSettings[casinoType || CASINO_TYPE.CASINO];

    return formatOtherSettingsGamesService(otherSettingsGameService);
  }, [casinoType, gamesServices, otherSettings]);
};
